import * as v1 from './payment';
import * as v2 from './paymentV2';

export type PaymentApi = typeof v1;

export const buildPaymentApi = (pciPaymentApiEnabled: boolean): PaymentApi => (pciPaymentApiEnabled ? v2 : v1);
